import { ReactNode } from "react";

export function SplittedPageLeft({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={className}>{children}</div>;
}
